(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name tracking.factory:TrackingAdaptorFactory
     *
     * @description
     *
     */
    angular
        .module('tracking')
        .factory('TrackingAdaptorFactory', TrackingAdaptorFactory);

    function TrackingAdaptorFactory(applicationConstants, trackingConstants) {

        var getAdaptedRegulationMap = function (regulationMap) {
            var adaptedRegulationMap = [];

            var isViolated = function (regulations) {
                var found = _.find(regulations, function (obj) {
                    return !obj.legalDay1 || !obj.legalDay2
                });
                if (!!found) {
                    return true;
                } else {
                    return false;
                }
            };

            if (!!regulationMap) {
                angular.forEach(Object.keys(regulationMap), function (key) {
                    adaptedRegulationMap.push({
                        regulationBlockName: key,
                        isViolated: isViolated(regulationMap[key]),
                        regulations: regulationMap[key]
                    });
                });
            }
            return adaptedRegulationMap;
        };

        var getSearchTrackingFlightAdaptor = function (trackingSearchResponse, aircraftList) {
            var adapted = [];

            var getPairs = function (airCraftRegistrationID, flightPairsCol) {
                var pairs = [];

                var updateWarningFlags = function (flight, flags) {
                    flags.crewComposition = flags.crewComposition || flight.pairingsOpen;
                    flags.genderWarnings = flags.genderWarnings || flight.genderWarningExsist;
                    flags.illagalNextWarning = flags.illagalNextWarning || flight.nextDutyIllegal;
                    flags.illagalCurrentWarning = flags.illagalCurrentWarning || flight.illegLCrewExsist;
                    flags.crewExpiryWarnings = flags.crewExpiryWarnings || flight.expiredCrewExists;
                    flags.languageWarnings = flags.languageWarnings || flight.languageWarningExsist;
                };

                angular.forEach(flightPairsCol, function (flightPair) {
                    var p = {};
                    var warningFlags = {
                        crewComposition: false,
                        genderWarnings: false,
                        languageWarnings: false,
                        illagalNextWarning: false,
                        illagalCurrentWarning: false,
                        crewExpiryWarnings: false
                    };
                    var tmpLeft = _.where(flightPair.left, {aircraftId: airCraftRegistrationID});
                    var tmpRight = _.where(flightPair.right, {aircraftId: airCraftRegistrationID});

                    angular.forEach(tmpLeft, function (flight) {
                        flight.isRight = false;
                        updateWarningFlags(flight, warningFlags);
                    });

                    angular.forEach(tmpRight, function (flight) {
                        flight.isRight = true;
                        updateWarningFlags(flight, warningFlags);
                    });

                    p.isFlightPair = !!tmpLeft.length && !!tmpRight.length;
                    p.flights = _.union(tmpLeft, tmpRight);
                    if (!!p.flights.length) {
                        var tmpSorted = _.sortBy(p.flights, function (f) {
                            var tDepData = f.actDeptDate || f.estDeptDate;
                            var tDepTime = f.actDeptTime || f.estDeptTime;
                            return moment(tDepData + ' ' + tDepTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                        });

                        p.pairStartDate = tmpSorted[0].actDeptDate || tmpSorted[0].estDeptDate;
                        p.pairStartTime = tmpSorted[0].actDeptTime || tmpSorted[0].estDeptTime;
                        p.pairEndDate = tmpSorted[tmpSorted.length - 1].actArvlDate || tmpSorted[tmpSorted.length - 1].estArvlDate;
                        p.pairEndTime = tmpSorted[tmpSorted.length - 1].actArvlTime || tmpSorted[tmpSorted.length - 1].estArvlTime;

                        p.flags = warningFlags;
                        pairs.push(p);
                    }
                });
                return pairs;
            };

            if (!!aircraftList) {
                angular.forEach(aircraftList, function (airCraft, key) {
                    var temp = {};
                    temp = {
                        id: key + 1,
                        modelNumber: airCraft.modelNumber,
                        registrationID: airCraft.registrationID,
                        registrationName: airCraft.registrationName,
                        sharket: airCraft.sharket,
                        base: airCraft.base,
                        pairs: getPairs(airCraft.registrationID, trackingSearchResponse.flightPairs)
                    };

                    temp.pairsUntouch = temp.pairs;
                    adapted.push(temp);
                });
            }

            // open pairing data
            var tempOpenPairings = {
              id: aircraftList.length + 1,
              modelNumber: null,
              registrationID: null,
              registrationName: null,
              sharket: null,
              base: null,
              pairs: getPairs(null, trackingSearchResponse.openFlights)
            };

            tempOpenPairings.pairsUntouch = tempOpenPairings.pairs;
            adapted.push(tempOpenPairings);

            return adapted;
        };


        function getPatterByIdAdaptor(response, flightDiscrepancies, crewIdsForPairing, assignCrewCountByGender) {

            var getOpenPairings = function (patternId) {
                var openPairings = [];
                if (patternId && flightDiscrepancies && flightDiscrepancies.openPairingDTOs) {
                    openPairings =   _.where(flightDiscrepancies.openPairingDTOs, {patternId: patternId})
                }
                return openPairings;
            };

            var getValidationExpiredCrews = function (patternId) {
                var validationExpired = [];
                if (patternId && flightDiscrepancies && flightDiscrepancies.validationExpiredCrews) {
                    validationExpired = _.where(flightDiscrepancies.validationExpiredCrews, {patternId: patternId})
                }
                return validationExpired;
            };

            var getGenderWarnings = function (patternId) {
                var genderWarnings = [];
                if (flightDiscrepancies && assignCrewCountByGender) {
                    var flightGender = _.groupBy(flightDiscrepancies.genderDTOs, 'gender');
                    var assignedObj = assignCrewCountByGender[patternId];

                    if (!!assignedObj) {
                        var requirment = flightGender[assignedObj.gender] &&
                            flightGender[assignedObj.gender][0] &&
                            flightGender[assignedObj.gender][0].requireCount;

                        if (requirment && requirment > 0) {
                            assignCrewCountByGender[patternId]['requireCount'] = requirment;
                            genderWarnings.push(assignCrewCountByGender[patternId]);
                        }
                    }
                }
                return genderWarnings;
            };

            var getLanguageWarnings = function (patternId) {
                var languageWarnings = [];
                if (!!flightDiscrepancies && flightDiscrepancies.languageDTOs) {
                    angular.forEach(flightDiscrepancies.languageDTOs, function (langObj) {
                        if(langObj.patternId == patternId){
                            languageWarnings.push(langObj);
                        }
                    });
                }
                return languageWarnings;
            }

            var getNextDutyIllegalList = function (pattern) {
                var list = [];
                if (pattern && flightDiscrepancies && flightDiscrepancies.nextDutyIllegalList) {
                    angular.forEach(flightDiscrepancies.nextDutyIllegalList, function (obj, key) {
                        if (
                            crewIdsForPairing &&
                            (crewIdsForPairing.length > 0) &&
                            (crewIdsForPairing.indexOf(String(obj.crewProfileId)) >= 0)) {
                            list.push(obj);
                        }
                    });
                }
                return list;
            };

            var getDtyIllegalCrews = function (patternId) {
                var list = [];
                if (patternId && flightDiscrepancies && flightDiscrepancies.dutyIllegalCrews) {
                    list = _.where(flightDiscrepancies.dutyIllegalCrews, {patternId: patternId});
                }
                return list;
            };

            var getDiscrepancyList = function (pattern) {
                var list = [];

                var getDiscrepanceyObj = function (msgParam, typeParam, isSubtypeSelectable) {
                    return {
                        msg: msgParam,
                        type: typeParam || '',
                        isSubtype: isSubtypeSelectable || false
                    };
                };

                var getOpenPairingDiscrepancies = function (pattern) {
                    var tmp = null;
                    if (pattern.openPairing.length > 0) {
                        tmp = {
                            type: trackingConstants.DESCRIPANCY_TYPES.OPEN_PAIR,
                            styleClass: 'yellow',
                            messages: []
                        };

                        angular.forEach(pattern.openPairing, function (openPairings) {
                            var tMsg = openPairings.crewTypeCode + ' : ' + openPairings.requiredCrew + ' Required and ' +(openPairings.assignedCrew || 0 )+ ' Assigned';
                            tmp.messages.push(getDiscrepanceyObj(tMsg, openPairings.crewTypeCode, true));
                        });
                    }
                    return tmp;
                };

                var getExpiries = function (pattern) {
                    var tmp = null;
                    if (pattern.validationExpiredCrews.length > 0) {
                        tmp = {
                            type: trackingConstants.DESCRIPANCY_TYPES.EXP_WARNING,
                            styleClass: 'orange',
                            messages: [getDiscrepanceyObj(pattern.validationExpiredCrews.length + ' Crew member(s) has Expiry Warnings')]
                        };
                    }
                    return tmp;
                };

                var getCurrentDutyDiscrepancies = function (pattern) {
                    var tmp = null;
                    if (pattern.dutyIllegalCrews.length > 0) {
                        tmp = {
                            type: trackingConstants.DESCRIPANCY_TYPES.CURR_ILLEGAL,
                            styleClass: 'lightblue',
                            messages: [getDiscrepanceyObj(pattern.dutyIllegalCrews.length + ' Crew Member(s) CURRENT DUTY ILLEGAL')]
                        };
                    }
                    return tmp;
                };

                var getNextDutyDiscrepancies = function (pattern) {
                    var tmp = null;
                    if (pattern.nextDutyIllegalList.length > 0) {
                        tmp = {
                            type: trackingConstants.DESCRIPANCY_TYPES.NEXT_ILLEGAL,
                            styleClass: 'green',
                            messages: [getDiscrepanceyObj(pattern.nextDutyIllegalList.length + ' Crew Member(s) Next DUTY ILLEGAL')]
                        };
                    }
                    return tmp;
                };

                var getGenderDiscrepancies = function (pattern) {
                    var tmp = null;
                    if (pattern.genderWarnings.length > 0) {
                        tmp = {
                            type: trackingConstants.DESCRIPANCY_TYPES.GENDER_WARNING,
                            styleClass: 'purple',
                            messages: []
                        };

                        angular.forEach(pattern.genderWarnings, function (warning) {
                            var tMsg = warning.gender + ' : ' + warning.requireCount + ' more Required and  ' + warning.assignedCount + ' Assigned';
                            tmp.messages.push(getDiscrepanceyObj(tMsg, warning.gender));
                        });
                    }
                    return tmp;
                }

                var getLanguageDescrepancies = function (pattern) {
                    var tmp = null;
                    if (pattern.languageWarnings.length > 0) {
                        tmp = {
                            type: trackingConstants.DESCRIPANCY_TYPES.LANG_WARNING,
                            styleClass: 'red',
                            messages: []
                        };
                        var tMsg;
                        angular.forEach(pattern.languageWarnings, function (warning) {
                            tMsg = warning.languageCode + ' : ' + warning.requiredCount + ' more Required';
                            tmp.messages.push(getDiscrepanceyObj(tMsg, warning.languageCode, true));
                        });
                    }
                    return tmp;
                }

                var addItemToList = function (list, item) {
                    item.id = list.length + 1;
                    list.push(item);
                }

                var tmp;
                if (!!(tmp = getOpenPairingDiscrepancies(pattern))) {
                    addItemToList(list, tmp);
                }
                if (!!(tmp = getExpiries(pattern))) {
                    addItemToList(list, tmp);
                }
                if (!!(tmp = getCurrentDutyDiscrepancies(pattern))) {
                    addItemToList(list, tmp);
                }
                if (!!(tmp = getNextDutyDiscrepancies(pattern))) {
                    addItemToList(list, tmp);
                }
                if (!!(tmp = getGenderDiscrepancies(pattern))) {
                    addItemToList(list, tmp);
                }
                if (!!(tmp = getLanguageDescrepancies(pattern))) {
                    addItemToList(list, tmp);
                }
                return list;
            }

            if (response && response.pattern) {
                var adapted = response.pattern;
                adapted.openPairing = getOpenPairings(adapted.patternId);
                adapted.validationExpiredCrews = getValidationExpiredCrews(adapted.patternId);
                adapted.nextDutyIllegalList = getNextDutyIllegalList(adapted);
                adapted.dutyIllegalCrews = getDtyIllegalCrews(adapted.patternId);
                adapted.genderWarnings = getGenderWarnings(adapted.patternId);
                adapted.languageWarnings = getLanguageWarnings(adapted.patternId);
                adapted.discrepancyList = getDiscrepancyList(adapted);
                adapted.startDate = adapted.blockList[0].blockStartDateStr;
                adapted.startTime = adapted.blockList[0].blockStartTimeStr;
                adapted.endDate = adapted.blockList[adapted.blockList.length - 1].blockEndDateStr;
                adapted.endTime = adapted.blockList[adapted.blockList.length - 1].blockEndTimeStr;
                return adapted;
            } else {
                return null;
            }
        }

        function getCrewForPairingAdaptor(response) {
            return (response && response.assignedCrewDTOs ) || [];
        }

        function getSugestedCrewListAdaptor(response) {
            var adapted = [];
            if (response && response.crewDTOsDiscrepancyMap) {
                angular.forEach(Object.keys(response.crewDTOsDiscrepancyMap), function (crewType) {
                    adapted = _.union(adapted, response.crewDTOsDiscrepancyMap[crewType]);
                });
            }

            return adapted;
        }

        function getUnassignedCrewListAdaptor(response) {
            var adapted = [];
            if (response && response.blankDayDTO) {
                adapted = response.blankDayDTO;

            }

            return adapted;
        }

        function getAssignCrewToPairingAdaptor(response) {
            response.adaptedRegulationMap = getAdaptedRegulationMap(response.regulationMap);
            return response;
        };

        function getSwapResponseAdaptor(response, crewCol) {
            response.crewWiseRegulationMap = [];
            if (!!response.responseMap) {
                var crew;
                var tmp;
                angular.forEach(Object.keys(response.responseMap), function (crewProfileId) {
                    crew = _.findWhere(crewCol, {crewProfileId: parseInt(crewProfileId)});
                    tmp = response.responseMap[crewProfileId];
                    tmp.groupFieldOne = crewProfileId;
                    tmp.groupFieldTwo = (crew && crew.name) || '';
                    tmp.adaptedRegulationMap = getAdaptedRegulationMap(tmp.regulationMap);
                    response.crewWiseRegulationMap.push(tmp);
                });
            }

            return response;
        };

        return {
            assignCrewToPairingAdaptor: getAssignCrewToPairingAdaptor,
            searchTrackingFlightAdaptor: getSearchTrackingFlightAdaptor,
            patterByIdAdaptor: getPatterByIdAdaptor,
            getCrewForPairingAdaptor: getCrewForPairingAdaptor,
            getSugestedCrewListAdaptor: getSugestedCrewListAdaptor,
            swapResponseAdaptor: getSwapResponseAdaptor,
            getUnassignedCrewListAdaptor: getUnassignedCrewListAdaptor
        };
    }
}());
